import { Controller } from "@hotwired/stimulus"

export default class ShareController extends Controller {
  static values = { url: String, text: String }
  static targets = ["nativeBtn"]

  declare urlValue: string
  declare textValue: string
  declare nativeBtnTarget: HTMLElement

  connect(): void {
    if (!navigator.share) {
      this.nativeBtnTarget.style.display = "none"
    }
  }

  native(event: Event): void {
    event.preventDefault()
    navigator.share({ text: this.textValue, url: this.urlValue }).catch(() => {})
  }

  line(event: Event): void {
    event.preventDefault()
    const url = `https://line.me/R/share?text=${encodeURIComponent(this.textValue + "\n" + this.urlValue)}`
    window.open(url, "_blank", "noopener")
  }

  x(event: Event): void {
    event.preventDefault()
    const url = `https://x.com/intent/tweet?text=${encodeURIComponent(this.textValue)}&url=${encodeURIComponent(this.urlValue)}`
    window.open(url, "_blank", "noopener")
  }
}
